"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyMetaConfigSchema = exports.NotifyAdditionalConfigSchema = exports.NotifyMetaConfigSchemaObj = exports.NotifyAdditionalConfigSchemaObj = exports.notifyCategoryDtoSchema = exports.notifyUserDtoSchema = exports.CategoryLanguage = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const NO_SPACE_REGEX = /^\S.*\S$|^\S$/;
var CategoryLanguage;
(function (CategoryLanguage) {
    CategoryLanguage["English"] = "en";
    CategoryLanguage["Spanish"] = "es";
})(CategoryLanguage || (exports.CategoryLanguage = CategoryLanguage = {}));
exports.notifyUserDtoSchema = yup_lib_1.default.object().shape({
    email: yup_lib_1.default.string().email().required().max(320).label('Email'),
    isAdmin: yup_lib_1.default.boolean().required()
});
exports.notifyCategoryDtoSchema = yup_lib_1.default.object().shape({
    title: yup_lib_1.default.string().required().label('Category Title'),
    description: yup_lib_1.default.string().notRequired().label('Category Description'),
    language: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(CategoryLanguage))
        .required()
        .label('Category Language')
});
exports.NotifyAdditionalConfigSchemaObj = {
    friendlyName: yup_lib_1.default
        .string()
        .matches(NO_SPACE_REGEX, 'Service Name cannot have leading or trailing whitespace')
        .required()
        .label('Service Name'),
    users: yup_lib_1.default.array().of(exports.notifyUserDtoSchema).required(),
    categories: yup_lib_1.default.array().of(exports.notifyCategoryDtoSchema).required()
};
exports.NotifyMetaConfigSchemaObj = {
    serviceSid: yup_lib_1.default.string().required()
};
exports.NotifyAdditionalConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.NotifyAdditionalConfigSchemaObj);
exports.NotifyMetaConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.NotifyMetaConfigSchemaObj);
